import { FC, useEffect, useMemo, useState } from "react"
import Input from '@atomaro/ui-kit/components/Input/Input';
import { SearchIcon } from "../icons/searchIcon";
import { SearchListBody, SearchListInputWrapper, SearchListItem, SearchListSector } from "./style";
import { CheckIcon } from "../icons/checkIcon";
import { COLORS } from "shared/consts";

type SearchListItem = {
  id: string;
  name: string;
  isSelected: boolean;
}

type SearchListProps = {
  items: SearchListItem[];
  isDrawer?: boolean;
  onItemClick: (id: string) => void;
}

export const SearchList: FC<SearchListProps> = ({
  items,
  isDrawer,
  onItemClick,
}) => {

  const selectedItems = useMemo(() => {
    return items.filter(el=>el.isSelected)
  }, [items])

  const notSelectedItems = useMemo(() => {
    return items.filter(el=>!el.isSelected)
  }, [items])

  const [ searchedItems, setSearchedItems ] = useState<SearchListItem[]>(notSelectedItems);
  const [ searchValue, setSearchValue ] = useState<string>('');

  const search = () => {
    if (searchValue.trim()) {
      setSearchedItems(notSelectedItems.filter(el=>el.name.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())))
    } else {
      setSearchedItems(notSelectedItems);
    }
  }

  useEffect(() => {
    setSearchedItems(notSelectedItems);
    setSearchValue('');
  }, [notSelectedItems])

  useEffect(() => {
    search();
  }, [searchValue])


  return (
    <>
    <SearchListInputWrapper $isDrawer={isDrawer}>
      <Input 
        iconPrefix={<SearchIcon />}
        value={searchValue}
        onChange={event => setSearchValue(event.target.value)}
        placeholder="Поиск"
        size="m"
      />
    </SearchListInputWrapper>
    <SearchListBody $isDrawer={isDrawer}>
      {Boolean(selectedItems.length) && 
      <SearchListSector>
        <span>Выбрано {selectedItems.length}</span>
        {selectedItems.map(item => (
          <SearchListItem key={item.id} $isActive={item.isSelected} onClick={() => onItemClick(item.id)}>
            <CheckIcon fill={item.isSelected ? COLORS.ACCENT.DEFAULT : undefined} />
            <span>{item.name}</span>
          </SearchListItem>
        ))}
      </SearchListSector>
      }
      <SearchListSector>
        {searchedItems.map(item => (
          <SearchListItem key={item.id} $isActive={item.isSelected} onClick={() => onItemClick(item.id)}>
            <CheckIcon fill={item.isSelected ? COLORS.ACCENT.DEFAULT : undefined} />
            <span>{item.name}</span>
          </SearchListItem>
        ))}
      </SearchListSector>
    </SearchListBody>
    </>
  )
}